import {
  AssessmentFormKey,
  FieldMapValue,
  Form,
  FormData,
  FormStatus,
  getAssessmentField,
  getCallInForm,
  getIntroductionForm,
  PopulatedAssessment,
} from '@hb/shared'
import { get as nestedGet } from 'nested-property'
import { useMemo } from 'react'
import { getFormStatus } from './utils'

// const getIntroductionForm = (formData: FieldMapValue | undefined): Form => {
//   const primaryCoverageField = getPregnancyPrimaryCoverageField(formData?.insuranceInfo)
//   const secondaryCoverageField = getPregnancySecondaryCoverageField(formData?.insuranceInfo)
//   const children: FieldMap['children'] = {
//     ...insuranceInfoStage.children,
//   }
//   if (primaryCoverageField) {
//     children.primaryCoverage = primaryCoverageField
//   }
//   if (secondaryCoverageField) {
//     children.secondaryCoverage = secondaryCoverageField
//   }
//   return {
//     ...introduction,
//     stages: {
//       ...introduction.stages,
//       insuranceInfo: getInsuranceInfoStage(formData?.insuranceInfo),
//     },
//   }
// }

export const useAssessmentForm = (
  admin: boolean,
  assessment: Omit<PopulatedAssessment, 'availableForms' | 'stages' | 'plans'> | null,
  id: AssessmentFormKey | null | undefined,
): FormData => {
  const form = useMemo<Form | null>(() => {
    const f = id ? getAssessmentField(admin, id, assessment) : null
    if (typeof f === 'string') return null
    switch (id) {
      case 'introduction':
        return getIntroductionForm(admin, assessment)
      case 'call-in':
        return getCallInForm(admin, assessment)
      default:
        return f
    }
  }, [id, assessment, admin])

  const data = useMemo(() => {
    if (!form) return undefined
    const assessmentData = admin ? assessment?.mergedData : assessment?.data
    return form.path
      ? (nestedGet(assessmentData, form.path) as FieldMapValue | undefined)
      : assessmentData
  }, [form, assessment, admin])
  const status = useMemo<FormStatus>(() => getFormStatus(form, data), [data, form])

  return { form, status }
}
